/**
 * Customer website (search, lists, detail pages, wishlist, profile at /stays,
 * /spas, /tours, /packages, /wishlist, /profile, /login and the website home
 * page at /). Off for now: the original landing page is shown at / and the
 * website routes fall through to it. Flip to true to publish the website.
 */
export const SITE_ENABLED = false;
